import { Outlet } from 'react-router-dom';

import {
  Box,
  useDisclosure,
  Drawer,
  useColorModeValue,
  DrawerContent,
} from '@chakra-ui/react';

import Companion from 'companion';
import useToastNotif from 'hooks/useToastNotif';
import MobileNav from 'components/common/sidebar/MobileNav';
import SidebarContent from 'components/common/sidebar/SidebarContent';
import Header from 'components/common/header';
import Footer from 'components/common/footer';
import CoursePreviewMd from 'components/course/modals/CoursePreviewMd';
import UserProfileMd from 'components/user/modals/UserProfileMd';
import AvatarSetupMd from 'components/user/modals/AvatarSetupMd';

function RootLayout() {
  useToastNotif();

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Companion />
      <CoursePreviewMd />
      <UserProfileMd />
      <AvatarSetupMd />

      {/*  */}
      <Header />
      <Box minH="100vh" bg={useColorModeValue('white', 'gray.900')}>
        <SidebarContent
          onClose={() => onClose}
          display={{ base: 'none', md: 'block' }}
        />
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          returnFocusOnClose={false}
          onOverlayClick={onClose}
          size="full"
        >
          <DrawerContent>
            <SidebarContent onClose={onClose} />
          </DrawerContent>
        </Drawer>

        <MobileNav display={{ base: 'flex', md: 'none' }} onOpen={onOpen} />
        <Box h="full">
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </>
  );
}

export default RootLayout;
